import { render, staticRenderFns } from "./Playground.vue?vue&type=template&id=671274a6&scoped=true&"
import script from "./Playground.vue?vue&type=script&lang=js&"
export * from "./Playground.vue?vue&type=script&lang=js&"
import style0 from "./Playground.vue?vue&type=style&index=0&id=671274a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671274a6",
  null
  
)

export default component.exports